import api from "../utils/api.js";
import {_} from 'vue-underscore';
import {SIZE_TOKENS, SIZE_TOKEN} from '../../config.js';
import events from '../utils/events.js';
import { trackEvent } from '../utils/tracking';

export const onboarding = {
    namespaced: true,
    state: {
        userOptionValues: [],
        userRiskValue: null,
        trainingOutfits: [],
        animationOutfits: [],
        isLoadingTrainingOutfits: false,
        isLoadingAnimatedOutfits: false,
        stepPromises: [],
        steps: [
            {
                title: 'How old are you?',
                subTitle: null,
                token: 'age',
                type: 'birth',
                loadOptions: true,
                options: [],
                isForm: false,
                noSkip: true,
                noSkipMessage: true,
                extraData: null,
            },
            {
                title: 'How would you describe your style?',
                subTitle: 'Choose all that apply',
                token: 'style',
                type: 'column-list',
                loadOptions: true,
                options: [],
                isForm: false,
                noSkip: true
            },
            {
                title: 'What types of outfits are you looking for?',
                subTitle: 'Choose all that apply',
                token: 'occasion',
                type: 'column-list',
                loadOptions: true,
                options: [],
                isForm: false,
                noSkip: true
            },
            {
                title: 'What colors do you NOT like to wear?',
                subTitle: 'Choose all that apply',
                token: 'color',
                type: 'color',
                loadOptions: true,
                options: [],
                isForm: false,
                noSkip: false
            },
            {
                title: 'What size do you typically wear? ',
                subTitle: null,
                token: 'size',
                type: 'size',
                loadOptions: true,
                options: [],
                isForm: false,
                noSkip: false
            },
            {
                title: 'What is your body type?',
                subTitle: null,
                token: 'body-type',
                type: 'full-list',
                loadOptions: true,
                options: [],
                isForm: false,
                noSkip: false
            },
            {
                title: 'How comfortable are you with taking risks?',
                subTitle: null,
                token: 'risk',
                type: 'risk',
                loadOptions: true,
                options: [],
                isForm: false,
                noSkip: true
            },
            {
                title: 'What are you willing to splurge on?',
                subTitle: 'Choose all that apply',
                token: 'budget-category',
                type: 'column-list',
                loadOptions: true,
                options: [],
                isForm: false,
                noSkip: false
            },
            {
                nextBtnTitle: 'Accept',
                token: 'agreements',
                type: 'agreements',
                loadOptions: false,
                options: [],
                isForm: false,
                noSkip: true
            },
            {
                title: 'Almost there!',
                subTitle: 'Just a few more details while we create outfits for you',
                nextBtnTitle: 'Start shopping',
                token: 'account',
                type: 'account',
                loadOptions: false,
                options: [],
                isForm: true,
                noSkip: false
            },
            /*
             {
             title: 'Billing & Shipping (optional)',
             subTitle:null,
             stepClass: 'step-10',
             token: 'billing',
             type: 'billing',
             loadOptions: false,
             options: [],
             isForm:true
             },
             */
        ]
    },
    getters: {
        steps(state){
            return state.steps;
        },
        step: (state) => (stepNumber) => {
            return state.steps[stepNumber];
        },
        userOptionValues(state){
            return state.userOptionValues;
        },
        userRiskValue(state){
            return state.userRiskValue;
        },
        numberOfSteps(state){
            return state.steps.length;
        },
        isLoadingTrainingOutfits(state) {
            return state.isLoadingTrainingOutfits;
        },
        isLoadingAnimatedOutfits(state) {
            return state.isLoadingAnimatedOutfits;
        },
        currentTrainingOutfit(state) {
            return state.trainingOutfits[0] || null;
        },
        currentAnimationOutfit(state) {
            return state.animationOutfits[0] || null;
        },
        hasMoreTrainingOutfits(state) {
            return state.trainingOutfits.length > 1;
        }
    },
    mutations: {
        setStepOptions(state, payload){
            state.steps[payload.stepNumber].options = payload.options;
        },
        addStepOptions(state, payload){
            state.steps[payload.stepNumber].options.push(payload.options);
        },
        removeUserOptionValues(state, optionValues) {
            state.userOptionValues = state.userOptionValues.filter(function(value) { return !optionValues.includes(value) })
        },
        addUserOptionValues(state, optionValues){
            let newOptions = optionValues.filter(function(value) { return !state.userOptionValues.includes(value) })
            state.userOptionValues = [
                ...state.userOptionValues,
                ...newOptions
            ]
        },
        resetUserOptionValues(state){
            state.userOptionValues = [];
        },
        setUserRiskValue(state, value){
            state.userRiskValue = value;
        },
        resetState(state){
            state.userOptionValues = [];
            state.userRiskValue = null;
        },
        setExtraData(state, payload) {
            state.steps[payload.stepNumber].extraData = payload.extraData;
        },
        setLoadingTrainingOutfits(state, isLoading) {
            state.isLoadingTrainingOutfits = isLoading;
        },
        setLoadingAnimatedOutfits(state, isLoading) {
            state.isLoadingAnimatedOutfits = isLoading;
        },
        setTrainingOutfits(state, outfits) {
            state.trainingOutfits = outfits;
        },
        setAnimationOutfits(state, outfits) {
            state.animationOutfits = outfits;
        },
        nextTrainingOutfit(state) {
            if (state.trainingOutfits.length > 0) {
                state.trainingOutfits.splice(0, 1);
            }
        },
        nextAnimationOutfit(state) {
            if (state.animationOutfits.length > 0) {
                state.animationOutfits.splice(0, 1);
            }
        },
        setStepPromise(state, { promise, stepNumber }) {
            state.stepPromises[stepNumber] = promise;
        }
    },
    actions: {
        likeOutfit(context, payload) {
            const outfit = payload.outfit;
            events.trackEvent(
                'onboarding_like_outfit',
                {
                    outfitId: outfit.outfit_id,
                    outfitAltered: false,
                    isPersonalized: false,
                    outfitScore: outfit.outfit_score
                }
            );

            trackEvent("onboarding_like_outfit", {content_id: outfit.outfit_id});
        },
        rejectOutfit(context, payload) {
            const outfit = payload.outfit;
            events.trackEvent(
                'onboarding_reject_outfit',
                {
                    outfitId: outfit.outfit_id,
                    outfitAltered: false,
                    isPersonalized: false,
                    outfitScore: outfit.outfit_score
                }
            );

            trackEvent("onboarding_reject_outfit", {content_id: outfit.outfit_id});
        },
        loadStep(context, stepNumber){
            let loadingOptsPromise = context.dispatch('loadStepOptions', stepNumber);
            const stepPromise = context.state.stepPromises[stepNumber];

            if(stepPromise) {
                loadingOptsPromise = Promise.race([stepPromise, loadingOptsPromise]);
            }

            return loadingOptsPromise.then(() => {
                    context.commit('setStepPromise', {
                        promise: context.dispatch('loadStepOptions', stepNumber + 1), 
                        stepNumber: stepNumber + 1,
                    });
                })
        },
        loadStepOptions(context, stepNumber){
            let curStep = context.getters.step(stepNumber);

            if (curStep && curStep.loadOptions && curStep.options.length < 1) {
                if (curStep.token == SIZE_TOKEN) {
                    return context.dispatch('loadStepSizeOptions', stepNumber);
                }
                else {
                    let uri = api.filtersUri() + curStep.token;
                    return api
                        .get(uri)
                        .then((response) => {
                            return context.commit('setStepOptions', {
                                options: response.filter,
                                stepNumber: stepNumber
                            });
                        })
                        .catch((response) => {
                            console.log('error loading step options');
                        });
                }
            }
        },
        async loadStepSizeOptions(context, stepNumber){
            const uri = api.filtersUri();
            const promises = [];

            context.commit('setStepOptions', {
                stepNumber,
                options: []
            });

            for (let i = 0; i < SIZE_TOKENS.length; i++) {
                promises.push(api.get(uri + SIZE_TOKENS[i]));
            }
            
            const options = await Promise.all(promises);

            context.commit('setStepOptions', {
                stepNumber,
                options: options.map((response) => response.filter)
            });
        },
        async loadTrainingOutfits(context) {
            context.commit('setLoadingTrainingOutfits', true);
            let uri = api.outfitsUri();
            const data = await api.get(uri + '/training');

            // Save the outfits but randomize them
            context.commit('setTrainingOutfits', _.shuffle(data.outfits));
            context.commit('setLoadingTrainingOutfits', false);
            return data.outfits;
        },
        async loadAnimationOutfits(context) {
            context.commit('setLoadingAnimatedOutfits', true);
            let uri = api.outfitsUri();
            const data = await api.get(uri + '/animation');

            // Save the outfits but randomize them
            context.commit('setAnimationOutfits', _.shuffle(data.outfits));
            context.commit('setLoadingAnimatedOutfits', false);
            return data.outfits;
        },
        saveUserOptionValues(context){
            let uri = api.preferencesUri();
            api
                .post(uri, {product_option_value_ids: context.getters.userOptionValues})
                .then((response) => {
                    console.log(response.message);
                })
                .catch((response) => {
                    console.log('error saving all preferences')
                });
        },
        async fetchAgreement(context, {agreementType}) {
            let uri = api.agreementsUri();
            return api.get(`${uri}/${agreementType}`)
                .then((response) => {
                    return response;
                })
                .catch((response) => {
                    trackEvent("fetch_agreement_error", {agreementType});
                });
        },
    }
};